import { useParams } from 'react-router-dom'

import { ScalrBreadcrumb } from '@/components/customComponents'
import FilterBar from '@/components/FilterBar'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

import { FEATURE_MATRIX } from '@/config/features'
import { selectTenant, useAppSelector } from '@/store'

import PnlLensPage from '@/screens/clarityLens/PnlLensPage'
import SalesLensPage from '@/screens/clarityLens/SalesLensPage'
import SpendLensPage from '@/screens/clarityLens/SpendLensPage'
import { NotAllowedClarityPage } from '@/screens/error'

function LensPageContent() {
  const { id } = useParams()

  const tenant = useAppSelector(selectTenant)
  const features = FEATURE_MATRIX[tenant]

  return (
    <>
      <FilterBar pageId={id} />

      {id === 'sales-lens' &&
        (features.clarityLensSales ? (
          <>
            <SalesLensPage />
          </>
        ) : (
          <NotAllowedClarityPage pageTitle="Sales Clarity Lens" />
        ))}

      {id === 'spend-lens' &&
        (features.clarityLensSpend ? (
          <SpendLensPage />
        ) : (
          <NotAllowedClarityPage pageTitle="Spend Clarity Lens" />
        ))}

      {id === 'labor-lens' &&
        (features.clarityLensLabor ? (
          <div>Master Labor</div>
        ) : (
          <NotAllowedClarityPage pageTitle="Labor Clarity Lens" />
        ))}

      {id === 'pnl-lens' &&
        (features.clarityLensProfitAndLoss ? (
          <PnlLensPage />
        ) : (
          <NotAllowedClarityPage pageTitle="Profit & Loss Clarity Lens" />
        ))}
    </>
  )
}

export default function LensPages() {
  const { id } = useParams()

  return (
    <>
      <Card className="w-full">
        <CardHeader className="flex flex-row justify-between">
          <CardTitle>
            {id === 'pnl-lens' && 'Profit & Loss Lens'}
            {id === 'sales-lens' && 'Sales Lens'}
            {id === 'spend-lens' && 'Spend Lens'}
            {id === 'labor-lens' && 'Labor Lens'}
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <ScalrBreadcrumb
            breadcrumbItems={[{ label: 'Clarity Lens' }]}
            title={
              id === 'pnl-lens'
                ? 'Profit & Loss Lens'
                : id === 'sales-lens'
                  ? 'Sales Lens'
                  : id === 'spend-lens'
                    ? 'Spend Lens'
                    : id === 'labor-lens'
                      ? 'Labor Lens'
                      : ''
            }
          />
          <LensPageContent />
        </CardContent>
      </Card>
    </>
  )
}
